<template>
  <div :class="`main ${hasHeader ? 'hasHeader' : ''} ${hasFooter ? 'hasFooter' : ''}`"
       :style="{paddingTop: headerHeight/100 + 'rem',
       marginTop: -headerHeight/100 + 'rem',
       paddingBottom: footerHeight/100 + 'rem',
       marginBottom: -footerHeight/100 + 'rem'}">
    <div class="main-wrapper bg">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
  	name: "appMain",
    data() {
  		return {
  			hasHeader: true,
        hasFooter: true
      }
    },
    props: {
      headerHeight: {
        type: Number
      },
      footerHeight: {
        type: Number
      }
    },
    created: function () {
  		const {hasHeader, hasFooter} = this.$route.meta;
  		this.hasHeader = !!hasHeader;
  		this.hasFooter = !!hasFooter;
    }
  }
</script>
<style lang="scss" scoped>
  .main{
    height: 100%;
    width: 100%;

    &.hasHeader{
      padding-top: 1rem;
      margin-top: -1rem;
    }
    &.hasFooter{
      padding-bottom: 1.2rem;
      margin-bottom: -1.2rem;
    }
    .main-wrapper{
      height: 100%;
      font-size: 0.2rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/layouts/AppMain/index.vue